import { render, staticRenderFns } from "./PageViewVehicle.vue?vue&type=template&id=488460c2"
import script from "./PageViewVehicle.vue?vue&type=script&lang=js"
export * from "./PageViewVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports